module.exports = __webpack_public_path__ + "static/media/1.e610ae0e.png";